import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';
export function useEventListener(element, type, eventListener) {
  const $ = _c(5);
  const eventListenerRef = useRefWithCurrentValue(eventListener);
  let t0;
  let t1;
  if ($[0] !== element || $[1] !== eventListenerRef || $[2] !== type) {
    t0 = () => {
      const callCallback = event => {
        if (typeof eventListenerRef.current === "function") {
          eventListenerRef.current(event);
        } else {
          eventListenerRef.current.handleEvent(event);
        }
      };
      element.addEventListener(type, callCallback);
      return () => {
        element.removeEventListener(type, callCallback);
      };
    };
    t1 = [element, type, eventListenerRef];
    $[0] = element;
    $[1] = eventListenerRef;
    $[2] = type;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}